import { NumberSymbol } from "@angular/common";


// Product Colors
//export type ProductColor = 'white' | 'black' | 'red' | 'green' | 'purple' | 'yellow' | 'blue' | 'gray' | 'orange' | 'pink';



export class Product {
  id?: string;
  user?: string;
  name?: string;
  price?: number;
  salePrice?: number;
  discount?: number;
  pictures?: any[];
  shortDetails?: string;
  description?: string;
  stock?: number;
  newPro?: boolean;
  brand?: string;
  sale?: boolean;
  category?: string;
  tags?: string;
  //colors?: ProductColor[];
  stars?: number;
  nationalShipmentCost?: number;
  localShipmentCost?: number;
  shipmentTime?: number;
  department?: string;
  city?: string;

  constructor(
    id?: string,
    name?: string,
    price?: number,
    salePrice?: number,
    discount?: number,
    pictures?: any[],
    shortDetails?: string,
    description?: string,
    stock?: number,
    newPro?: boolean,
    brand?: string,
    sale?: boolean,
    category?: string,
    tags?: string,
    //colors?: ProductColor[],
    stars?: number,
    nationalShipmentCost?: number,
    localShipmentCost?: number,
    shipmentTime?: NumberSymbol,
    department?: string,
    city?: string
  ) {
    this.id = id;
    this.name = name;
    this.price = price;
    this.salePrice = salePrice;
    this.discount = discount;
    this.pictures = pictures;
    this.shortDetails = shortDetails;
    this.description = description;
    this.stock = stock;
    this.newPro = newPro;
    this.brand = brand;
    this.sale = sale;
    this.category = category;
    this.tags = tags;
    //this.colors = colors;
    this.stars = stars;
    this.nationalShipmentCost = nationalShipmentCost;
    this.localShipmentCost = localShipmentCost;
    this.shipmentTime = shipmentTime;
    this.department = department;
    this.city = city;
  }

 }
  // Color Filter
  export interface ColorFilter {
    //color?: ProductColor;
  }
